import { createContext, useContext } from 'react'
export const TimeFormatContext = createContext({})
export const useTimeFormat = () => useContext(TimeFormatContext)